const accessories = {
    state: {
        new: [],
        posix: new Date().toISOString().substr(0, 10)
    },
    mutations: {
        SET_NEW_ACCESSORIES_NAME(state, payload) {
            state.new[payload.index].name = payload.value
        },
        SET_NEW_ACCESSORIES_COST(state, payload) {
            state.new[payload.index].cost = payload.value
        },
        SET_NEW_ACCESSORIES(state, payload) {
            state.new = payload
        },
        SET_ACCESSORY_POSIX(state, payload) {
            state.posix = new Date(payload).toISOString().substr(0, 10)
        }
    },
    getters: {
        getNewAccessories: state => state.new,
        getAccessoriesPosix: state => state.posix,
        getNewAccessoriesValue(state) {
            if (!state.new[0]) {
                return 0
            }

            return state.new.map((el) => {
                if (el.cost) {
                    return el.cost
                }

                return 0
            }).reduce((accumulator, currentValue) => parseFloat(accumulator) + parseFloat(currentValue))
        }
    }
}

export default accessories